import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/Auth";
import SideNavigation from "../components/navigation/SideNavigation";
import CarouselModal from "../components/CarouselModal";
import PageTitle from "../components/PageTitle"; // import your component

const pathToTitle = {
    "/welcome": "Welcome",
    "/dashboard": "Dashboard",
    "/clocks": "Clocks",
    "/listeners/health": "Health",
    "/listeners/ratings": "Ratings",
    "/listeners/freestyle_deltas": "Freestyle Deltas",
    "/listeners/content_testing": "Content Testing",
    "/music/music_charts": "Music Charts",
    "/music/competitor_chart": "Competitor Chart",
    "/music/content_balance": "Content Balance",
    "/music/comparison": "Comparison",
    "/music/minute_by_minute": "Minute by Minute",
    "/music/song_search": "Song Search",
    "/music/music_testing": "Music Testing",
    "/music/playlist_autopilot": "PLAP",
    "/music/playlist_autopilot/custom": "Custom PLAP",
    "/music/playlist_autopilot/custom/song_matching": "Song Matching",
    "/music/playlist_autopilot/custom/results": "Playlist Results",
    "/music/predictor": "Predictor",
    "/music/schedule_check": "Schedule Check",
    "/music/hybrid_hitlist": "Hybrid Hitlist",
    "/reports/music_alerts": "Music Alerts",
    "/reports/music_reports": "Music Reports",
    "/reports/music_testing_reports": "Music Testing Reports",
    "/reports/virtual_assistant": "Virtual Assistant",
    "/settings/password": "Settings | Password",
    "/settings/dayparts": "Settings | Dayparts",
    "/settings/content_groups": "Settings | Content Groups",
    "/settings/predictor": "Settings | Predictor",
};

export default function Layout() {
    const { token } = useAuth();
    const location = useLocation();

    if (!token) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    const getTitleFromPath = path => {
        if (path.startsWith("/login/reset_password")) return "Reset Password";
        if (path.startsWith("/music/playlist_autopilot/custom")) return "Custom PLAP";
        return pathToTitle[path] || "RadioAnalyzer";
    };

    const currentTitle = getTitleFromPath(location.pathname);

    return (
        <>
            <PageTitle title={currentTitle} />
            <CarouselModal />
            <SideNavigation />
            <main>
                <Outlet />
            </main>
        </>
    );
}
